var _defs, _path, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _rect5, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIc140UnderConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 110,
    viewBox: "0 0 140 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_787",
    "data-name": "\\uD328\\uC2A4 787",
    className: "cls-1",
    d: "M0 0h134.513v94.963H0z",
    transform: "translate(112.75 253.981)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-5{fill:#fff}.cls-2{fill:none}.cls-4{fill:#e8e8e8}.cls-5{opacity:.6}.cls-8{fill:#4774cf}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "ic_140_under-construction",
    transform: "translate(-119 -234)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "base",
    className: "cls-2",
    transform: "translate(119 234)",
    d: "M0 0h140v110H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ico_\\uC810\\uAC80\\uC911",
    transform: "translate(8 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3",
    transform: "translate(.25 -6.981)",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1160",
    "data-name": "\\uADF8\\uB8F9 1160",
    transform: "translate(0 -.018)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3615",
    "data-name": "\\uC0AC\\uAC01\\uD615 3615",
    className: "cls-4",
    width: 73.734,
    height: 27.499,
    rx: 6,
    transform: "translate(114 290.299)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3617",
    "data-name": "\\uC0AC\\uAC01\\uD615 3617",
    className: "cls-4",
    width: 73.734,
    height: 27.499,
    rx: 6,
    transform: "translate(114 321.3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3616",
    "data-name": "\\uC0AC\\uAC01\\uD615 3616",
    className: "cls-5",
    width: 30.632,
    height: 4,
    rx: 2,
    transform: "translate(133.552 302.299)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3642",
    "data-name": "\\uC0AC\\uAC01\\uD615 3642",
    className: "cls-5",
    width: 30.632,
    height: 4,
    rx: 2,
    transform: "translate(133.552 333.299)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_491",
    "data-name": "\\uD0C0\\uC6D0 491",
    className: "cls-5",
    cx: 3,
    cy: 3,
    transform: "translate(123.592 301.299)",
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_497",
    "data-name": "\\uD0C0\\uC6D0 497",
    className: "cls-5",
    cx: 3,
    cy: 3,
    transform: "translate(123.592 332.299)",
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_3608",
    "data-name": "\\uC0AC\\uAC01\\uD615 3608",
    transform: "translate(147 255)",
    style: {
      stroke: "#424242",
      strokeWidth: "1.5px",
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.692,
    height: 104.023,
    rx: 10,
    style: {
      stroke: "none"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.75,
    y: 0.75,
    width: 70.192,
    height: 102.523,
    rx: 9.25
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3609",
    "data-name": "\\uC0AC\\uAC01\\uD615 3609",
    width: 13.522,
    height: 2.08,
    rx: 1.04,
    transform: "translate(176 261.241)",
    style: {
      fill: "#424242"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1158",
    "data-name": "\\uADF8\\uB8F9 1158",
    transform: "rotate(45 -247.36 382.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_267",
    "data-name": "\\uD569\\uCE58\\uAE30 267",
    className: "cls-8",
    d: "M4 48.3a4 4 0 0 1-4-4V26.921A4 4 0 0 1 1.923 23.5V.671C1.923.3 2.44 0 3.077 0L6.5 1.341a1.891 1.891 0 0 1 1.155 1.341V23.5a4 4 0 0 1 1.923 3.419V44.3a4 4 0 0 1-4 4z",
    transform: "translate(0 .696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_789",
    "data-name": "\\uD328\\uC2A4 789",
    className: "cls-8",
    d: "M2 0h4.9a2.024 2.024 0 0 1 2 2.047l1 7.366a2.024 2.024 0 0 1-2 2.047H1a2.024 2.024 0 0 1-2-2.047l1-7.366A2.024 2.024 0 0 1 2 0z",
    transform: "translate(.339)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_297",
    "data-name": "\\uD569\\uCE58\\uAE30 297",
    d: "M8.292 50.4a4 4 0 0 1-4-4v-29a10.12 10.12 0 0 1-2.386-1.774A10.013 10.013 0 0 1-1.045 8.5v-.224a7.923 7.923 0 0 1 .49-2.486A11.029 11.029 0 0 1 2.336 1.5q.165-.163.336-.325a.828.828 0 0 1 .168-.11l.05-.04A2.082 2.082 0 0 1 6 1.979v3.89c0 1.155.291 1.733 1.28 1.839a3.6 3.6 0 0 0 .366.018h2.717a3.6 3.6 0 0 0 .366-.018c.989-.105 1.28-.684 1.28-1.839v-3.89a2.153 2.153 0 0 1 3.183-.953l.049.04a.828.828 0 0 1 .168.11q.171.162.336.325a11.025 11.025 0 0 1 2.892 4.29 7.927 7.927 0 0 1 .485 2.489v.222a10.013 10.013 0 0 1-2.951 7.132 10.122 10.122 0 0 1-2.384 1.773v29a4 4 0 0 1-4 4z",
    transform: "rotate(-45 436.646 -43.324)",
    style: {
      fill: "#81a5ef"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_298",
    "data-name": "\\uD569\\uCE58\\uAE30 298",
    className: "cls-4",
    d: "M1.87 50.953a1.887 1.887 0 0 1 0-3.774H4.9c.3-1.272.7-2.9 1.153-4.527l10.833-38.63a5.509 5.509 0 0 1 10.609 0l10.834 38.629c.458 1.631.921 3.255 1.287 4.527h2.447a1.887 1.887 0 0 1 0 3.774z",
    transform: "translate(204.579 296.11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_759",
    "data-name": "\\uD328\\uC2A4 759",
    className: "cls-1",
    d: "M2.93 0h16.5l1.66 6.62H1.051z",
    transform: "translate(215.669 310.178)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_760",
    "data-name": "\\uD328\\uC2A4 760",
    className: "cls-1",
    d: "M1.462 0h25.217l1.867 6.62H-.4z",
    transform: "translate(212.732 325.952)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_7",
    "data-name": "\\uBE7C\\uAE30 7",
    d: "M20.85 50.918H10.793a1.87 1.87 0 0 0-.007-3.739h-3.38L3.337 4.021C2.882 1.919 1.635.447 0 .083A5.8 5.8 0 0 1 .976 0a5.393 5.393 0 0 1 5.305 4.021l10.835 38.63c.377 1.346.81 2.869 1.286 4.527h2.448a1.87 1.87 0 0 1 0 3.739z",
    transform: "translate(225.794 296.11)",
    style: {
      fill: "#dee0e5",
      opacity: 0.3,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc140UnderConstruction);
export default __webpack_public_path__ + "static/media/ic_140_under-construction.e7e77a8aa179f6a9e0c0c5282b95192c.svg";
export { ForwardRef as ReactComponent };